(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
/* MIZUKI desktop newsletter popover v2. Native Shopify form submission.
   Desktop: header trigger and same-shop #mizuki-newsletter links open the panel.
   Mobile: listeners return without cancelling existing links or animations.
   No email addresses are written to browser storage or third-party services. */
(() => {
  if (window.__mizukiDesktopNewsletterPopoverV2) return;
  window.__mizukiDesktopNewsletterPopoverV2 = true;

  const desktop = window.matchMedia('(min-width: 990px)');
  const panelSelector = '[data-mizuki-newsletter-panel]';
  const triggerSelector = '[data-mizuki-newsletter-trigger]';
  const pendingKey = 'mizuki-newsletter-desktop-pending-v2';
  let activePanel = null;
  let opener = null;
  let positionFrame = 0;
  let resultHandled = false;

  function visible(element) {
    return element instanceof HTMLElement && element.getClientRects().length > 0 &&
      window.getComputedStyle(element).visibility !== 'hidden';
  }

  function panelFor(trigger) {
    const id = trigger && trigger.getAttribute('aria-controls');
    const panel = id ? document.getElementById(id) : null;
    return (panel && panel.matches(panelSelector)) ? panel : document.querySelector(panelSelector);
  }

  function headerTrigger(panel) {
    return Array.from(document.querySelectorAll(triggerSelector)).find((button) =>
      button.getAttribute('aria-controls') === panel.id && visible(button));
  }

  function setExpanded(panel, expanded) {
    document.querySelectorAll(triggerSelector).forEach((button) => {
      if (button.getAttribute('aria-controls') === panel.id) {
        button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      }
    });
  }

  function closePanel(restoreFocus = false) {
    if (!activePanel) return;
    const panel = activePanel;
    const source = opener;
    activePanel = null;
    opener = null;
    window.cancelAnimationFrame(positionFrame);
    positionFrame = 0;
    panel.hidden = true;
    setExpanded(panel, false);
    if (restoreFocus && source && source.isConnected && visible(source)) {
      source.focus({ preventScroll: true });
    }
  }

  function positionPanel() {
    positionFrame = 0;
    const panel = activePanel;
    if (!panel) return;
    if (!desktop.matches || !panel.isConnected) { closePanel(); return; }
    const vw = document.documentElement.clientWidth;
    const vh = window.innerHeight;
    const source = headerTrigger(panel) || (visible(opener) ? opener : null);
    const rect = source ? source.getBoundingClientRect() : null;
    const top = Math.max(16, Math.min(rect ? rect.bottom + 10 : 100, vh - 160));
    const width = Math.min(360, vw - 32);
    const left = Math.max(16, Math.min(rect ? rect.right - width : vw - width - 24, vw - width - 16));
    panel.style.setProperty('--mizuki-newsletter-top', `${top}px`);
    panel.style.setProperty('--mizuki-newsletter-left', `${left}px`);
    panel.style.setProperty('--mizuki-newsletter-max-height', `${Math.max(120, vh - top - 16)}px`);
  }

  function schedulePosition() {
    if (activePanel && !positionFrame) positionFrame = window.requestAnimationFrame(positionPanel);
  }

  function openPanel(panel, source, focus = true) {
    if (!desktop.matches || !panel) return false;
    if (activePanel && activePanel !== panel) closePanel();
    activePanel = panel;
    opener = source || headerTrigger(panel) || null;
    panel.hidden = false;
    positionPanel();
    setExpanded(panel, true);
    if (focus) {
      const target = panel.querySelector('[data-mizuki-newsletter-result]') ||
        panel.querySelector('input[type="email"]') || panel.querySelector('[data-mizuki-newsletter-close]');
      if (target) target.focus({ preventScroll: true });
    }
    return true;
  }

  function isNewsletterLink(link) {
    if (!link || link.hasAttribute('download') ||
        (link.target && link.target.toLowerCase() !== '_self')) return false;
    try {
      const url = new URL(link.href, window.location.href);
      return url.origin === window.location.origin && url.hash === '#mizuki-newsletter';
    } catch (_) { return false; }
  }

  // Window capture runs before the existing mobile newsletter document handler.
  // Only these desktop controls are cancelled; mobile anchor behavior is untouched.
  window.addEventListener('click', (event) => {
    if (!desktop.matches || event.defaultPrevented || event.button !== 0 ||
        event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const element = event.target instanceof Element ? event.target : null;
    if (!element) return;
    const close = element.closest('[data-mizuki-newsletter-close]');
    if (close && activePanel && activePanel.contains(close)) {
      event.preventDefault();
      closePanel(true);
      return;
    }
    const trigger = element.closest(triggerSelector);
    const link = element.closest('a[href]');
    if (!trigger && !isNewsletterLink(link)) return;
    const panel = panelFor(trigger);
    if (!panel) return;
    event.preventDefault();
    if (trigger && activePanel === panel && !panel.hidden) closePanel(true);
    else openPanel(panel, trigger || link);
  }, true);

  window.addEventListener('pointerdown', (event) => {
    if (!activePanel || !(event.target instanceof Element)) return;
    if (activePanel.contains(event.target) || event.target.closest(triggerSelector)) return;
    // Keep the panel open when an existing newsletter announcement is clicked again.
    if (isNewsletterLink(event.target.closest('a[href]'))) return;
    closePanel(false);
  }, { capture: true, passive: true });

  window.addEventListener('keydown', (event) => {
    if (activePanel && event.key === 'Escape') {
      event.preventDefault();
      closePanel(true);
    }
  }, true);

  document.addEventListener('focusin', (event) => {
    if (!activePanel || !(event.target instanceof Element)) return;
    if (activePanel.contains(event.target) || event.target.closest(triggerSelector)) return;
    // A non-modal panel must not trap keyboard users or steal another control's focus.
    if (event.target.tagName !== 'IFRAME') closePanel(false);
  });

  window.addEventListener('resize', () => {
    if (!desktop.matches) closePanel(false);
    else schedulePosition();
  }, { passive: true });
  window.addEventListener('scroll', schedulePosition, { passive: true });
  desktop.addEventListener('change', () => { if (!desktop.matches) closePanel(false); });

  // Do not use fetch(), preventDefault(), or form.submit(): Shopify owns the POST,
  // email validation, and any CAPTCHA challenge. Store only a short-lived timestamp.
  window.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.closest(panelSelector)) return;
    if (!desktop.matches) return;
    const returnTo = form.querySelector('input[name="return_to"]');
    if (returnTo) {
      const url = new URL(window.location.href);
      url.searchParams.delete('customer_posted');
      url.searchParams.delete('contact_posted');
      url.hash = form.id;
      returnTo.value = url.pathname + url.search + url.hash;
    }
    try {
      window.sessionStorage.setItem(pendingKey, JSON.stringify({ id: form.id, at: Date.now() }));
    } catch (_) { /* The native form also works with browser storage disabled. */ }
  }, true);

  function restoreResult() {
    if (!desktop.matches || resultHandled) return;
    const panel = document.querySelector(panelSelector);
    if (!panel) return;
    const form = panel.querySelector('form');
    if (!form) return;
    const result = panel.querySelector('[data-mizuki-newsletter-result]');
    let pending = null;
    try { pending = JSON.parse(window.sessionStorage.getItem(pendingKey) || 'null'); } catch (_) {}
    const recent = pending && pending.id === form.id && Date.now() - pending.at < 15 * 60 * 1000;
    const ownHash = window.location.hash === `#${form.id}`;
    // Only server-rendered success/errors count as a submission result.
    // A stored timestamp or URL fragment alone never displays a success message.
    if (result && (recent || ownHash)) {
      resultHandled = true;
      try { window.sessionStorage.removeItem(pendingKey); } catch (_) {}
      openPanel(panel, headerTrigger(panel));
    } else if (ownHash) {
      resultHandled = true;
      openPanel(panel, headerTrigger(panel));
    }
  }

  document.addEventListener('shopify:section:unload', (event) => {
    if (activePanel && event.target instanceof Element && event.target.contains(activePanel)) closePanel(false);
  });
  document.addEventListener('shopify:section:load', restoreResult);
  window.addEventListener('pageshow', restoreResult);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', restoreResult, { once: true });
  else restoreResult();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
